import { render, staticRenderFns } from "./DeclinedComp.vue?vue&type=template&id=5e062dc9&scoped=true&"
import script from "./DeclinedComp.vue?vue&type=script&lang=js&"
export * from "./DeclinedComp.vue?vue&type=script&lang=js&"
import style0 from "./DeclinedComp.vue?vue&type=style&index=0&id=5e062dc9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e062dc9",
  null
  
)

export default component.exports